import * as React from 'react';
import * as PropTypes from 'prop-types';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form/immutable';

import renderField from '../../../../../components/Field/reduxForm';

export class PasswordField extends React.Component {
  static propTypes = {
    input: PropTypes.shape(fieldInputPropTypes).isRequired,
    meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  };

  state = {
    type: 'password',
  };

  handleToogleClick = () => {
    const nextType = this.state.type !== 'text' ? 'text' : 'password';

    this.setState({ type: nextType });
  };

  render() {
    const { input } = this.props;
    const { type } = this.state;

    return (
      <>
        {React.createElement(renderField, { ...this.props, type })}

        {input.value && input.value.length && (
          <a onClick={this.handleToogleClick}>
            {type === 'password' ? 'Показать пароль' : 'Скрыть пароль'}
          </a>
        )}
      </>
    );
  }
}
